module.exports = __webpack_public_path__ + "media/assets/images/flags/cf-5728450cc1860e36df366a01eb1e8e34.svg";